// extracted by mini-css-extract-plugin
export default {"Option":"Option_Option__B8sXk","OptionLabel":"Option_OptionLabel__cfC4t","OptionField":"Option_OptionField__sA7NK","total_ques-option":"Option_total_ques-option__1heSp"};